import { Injectable } from '@angular/core';

import { Select3dService } from '../../../services/select-3d.service';
import { ObjectControls } from '../../../services/object-controls.service';
import { CameraService } from '../../../services/camera.service';
import { StageService } from '../../../services/stage.service';
import { Subscription } from 'rxjs';
import { Drag3D } from '../Drag/drag3-d.service';
import { AwningResizeHandler } from './Handlers/AwningResizeHandler';
import { AwningResizeControls } from '../../../custom/Controls/AwningResizeControls';
import { ComponentBase } from '../../../component-base';
import { AwningDeleteHandler } from './Handlers/AwningDeleteHandler';
import { AwningDeleteControl } from '../../../custom/Controls/AwningDeleteControl';
import { SceneUtilsService } from '../../../services/scene-utils.service';

declare const THREE: any;

@Injectable()
export class AwningControlsService extends ComponentBase {
  private _handlers: any[] = [];
  private _controls: any;
  private _raycaster: any;
  private _selected: any;
  private _buttons: any;
  _selectedAwningSubscription: Subscription;
  _removeSubscription: Subscription;
  _clearSelectionSubscription: Subscription;
  dragUnsubscribe: () => void;

  constructor(
    private Select3D: Select3dService,
    private objectControls: ObjectControls,
    private stage: StageService,
    private drag3D: Drag3D,
    private awningResizeHandler: AwningResizeHandler,
    private awningResizeControls: AwningResizeControls,
    private awningDeleteHandler: AwningDeleteHandler,
    private awningDeleteControl: AwningDeleteControl,
    private cameraManager: CameraService,
    private sceneUtils: SceneUtilsService
  ) {
    super();
    this._handlers = [this.awningResizeHandler, this.awningDeleteHandler];
    this._controls = [this.awningResizeControls, this.awningDeleteControl];
    this._raycaster = new THREE.Raycaster();
    this._buttons = [...this.awningResizeControls.children, ...this.awningDeleteControl.children];

    this._selectedAwningSubscription = this.Select3D.selectedAwningSubject.subscribe(awnings => {
      if (awnings.length === 1) {
        this._selected = awnings[0];
        this._updateControls(true);
      }
    });

    this._removeSubscription = this.stage.objectRemoved.subscribe(() => {
      this._updateControls(false);
    });
    this._clearSelectionSubscription = this.Select3D.clearSelected.subscribe(() => {
      this._updateControls(false);
      this._selected = null;
    });

    this.dragUnsubscribe = this.drag3D.on(
      'drag',
      () => {
        this._updateControls(false);
      },
      this
    );
  }

  private _updateControls(visible: boolean) {
    this._controls.forEach(control => {
      if (this._selected) control.update(this._selected);
      control.visible = visible;
    });
  }

  private _getRay(x, y) {
    this.sceneUtils.getRay(x, y, this._raycaster);
    if (this.cameraManager.isIn2D()) this._raycaster.ray.origin.y = 500;
    return this._raycaster;
  }

  mouseDown(e: MouseEvent) {
    if (this._selected) {
      const ray = this._getRay(e.offsetX, e.offsetY);
      const intersection = ray.intersectObjects(this._buttons);
      if (intersection.length !== 0) {
        const { object: button } = intersection[0];
        const handler = this._handlers.find(h => h.name === button.parent.name) || null;

        if (handler) {
          handler.invoke(this._selected, button.name).then(() => this._updateControls(true));
          this.fireEvent('click', button);
          return true;
        }
      }
    }
  }

  move(e) {}

  release() {}

  disable() {
    super.disable();
    this.awningResizeControls.visible = false;
  }

  dispose() {
    super.dispose();
    this._selectedAwningSubscription.unsubscribe();
    this._removeSubscription.unsubscribe();
    this._clearSelectionSubscription.unsubscribe();
    this.dragUnsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/ObjectControls/awning-controls.service.ts